import { useState } from "react";

import { DetectedFile } from "../../types";
import { FileThumbnail } from "../FileThumbnail";
import { FilePreviewWrapper } from "../FilePreviewWrapper";
import { OverflowDisplayTooltip } from "../../../Tooltip/OverflowDisplayTooltip";

import { LinkIcon } from "./LinkIcon";
import { LinkPreview } from "./LinkPreview";
import { LinkEditForm } from "./LinkEditForm";

interface LinkDisplayProps {
  data: string;
  isViewing: boolean;
  setIsViewing: (isViewing: boolean) => void;
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
  saveData?: (newData: string, previousData: string, index?: number) => void;
  isInCollection?: boolean;
  detectedFile?: DetectedFile;
}

export const LinkDisplay = ({
  data,
  isViewing,
  setIsViewing,
  isEditing,
  saveData,
  setIsEditing,
  isInCollection = false,
  detectedFile,
}: LinkDisplayProps) => {
  const [imageError, setImageError] = useState(false);
  if (!detectedFile?.linkTypeInfo && !isInCollection) {
    return null;
  }

  const fileType =
    detectedFile?.linkTypeInfo && !imageError
      ? detectedFile.linkTypeInfo
      : {
          type: "link" as const,
          icon: "ExternalLink",
          label: "Web Link",
          error: detectedFile?.error || false,
        };

  return (
    <div className="relative">
      <div className="cursor-pointer rounded p-2 transition-colors hover:bg-gray-100">
        <FilePreviewWrapper
          isViewing={isViewing}
          setIsViewing={setIsViewing}
          trigger={
            <div>
              <FileThumbnail
                icon={
                  <LinkIcon
                    iconName={fileType.icon}
                    data={data}
                    onError={() => setImageError(true)}
                  />
                }
                title={fileType.label}
                subtitle={
                  <div className="flex items-center gap-1 text-xs text-gray-500">
                    <div className="flex w-full max-w-[150px]">
                      <OverflowDisplayTooltip side="bottom" content={data}>
                        <span>{data}</span>
                      </OverflowDisplayTooltip>
                    </div>
                  </div>
                }
                error={fileType.error}
              />
            </div>
          }
        >
          <LinkPreview data={data} detectedFile={detectedFile} imageError={imageError} />
        </FilePreviewWrapper>

        <LinkEditForm
          data={data}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          saveData={saveData}
        />
      </div>
    </div>
  );
};
